import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

const MultiSelectEditViewEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-multi-select-edit-view" */ './ui/multi-select'),
	),
	getPreloadProps: () => ({}),
});

export default MultiSelectEditViewEntryPoint;
